import { render, staticRenderFns } from "./zxjs.vue?vue&type=template&id=2d7ae880&scoped=true"
import script from "./zxjs.vue?vue&type=script&lang=js"
export * from "./zxjs.vue?vue&type=script&lang=js"
import style0 from "./zxjs.vue?vue&type=style&index=0&id=2d7ae880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ae880",
  null
  
)

export default component.exports